import { SupportMessageTags } from '@website/types/graphqlOperations';
import { DateTime } from 'luxon';
import Link from 'next/link';
import { useState } from 'react';
import { Button, Row } from 'react-bootstrap';
import HelpButton from '../../../HelpButton';
import ContactForm from '../../contactForm/ContactForm';
import { HelpBooking } from '../SelectBooking';
import BookAnotherSpace from './BookAnotherSpace';
import CancelChangeDatesOptions from './CancellationOptions';
import AskYourGuide from './GuideQuestion';

export default function IndividualBooking({
  booking,
  userID,
}: {
  booking: HelpBooking;
  userID: string;
}) {
  const [currentActiveKey, setActiveKey] = useState<string>();
  const buttonProps = { currentActiveKey, setActiveKey };

  // Create isInFuture boolean
  const isInFuture =
    DateTime.now() <
    DateTime.fromISO(booking.group.start.utc, {
      zone: 'utc',
    });

  return (
    <div className="mt-3">
      <h2 className="h4">How can we help with this booking?</h2>
      <Row className="mt-4">
        <HelpButton
          {...buttonProps}
          activeKey="viewDetails"
          text="View booking"
        >
          <div className="mt-3">
            <h2 className="h4">You can see this on your dashboard</h2>

            <p>
              You can view your booking at any time, by clicking on the menu at
              the top of every page, and then "My Dashboard". From here you can
              click on your booking to see all the details.
            </p>

            <p>Here's a link for your convenience:</p>

            <Link href="/me" legacyBehavior>
              <Button className="me-1 mb-1">My Dashboard</Button>
            </Link>
          </div>
        </HelpButton>

        {isInFuture && (
          <>
            <HelpButton
              {...buttonProps}
              activeKey="cancel"
              text="Cancellation options"
            >
              <CancelChangeDatesOptions
                userID={userID}
                booking={booking}
                type="cancel"
              />
            </HelpButton>

            <HelpButton
              {...buttonProps}
              activeKey="dateChange"
              text="Change dates"
            >
              <CancelChangeDatesOptions
                userID={userID}
                booking={booking}
                type="changeDates"
              />
            </HelpButton>

            <HelpButton
              {...buttonProps}
              activeKey="bookMore"
              text="Book another space"
            >
              <BookAnotherSpace booking={booking} />
            </HelpButton>
          </>
        )}

        <HelpButton
          {...buttonProps}
          activeKey="guideQuestion"
          text="Ask your guide a question"
        >
          <AskYourGuide booking={booking} />
        </HelpButton>

        <HelpButton
          {...buttonProps}
          activeKey="other"
          text="Tech/billing support"
        >
          <ContactForm
            defaultSubject={`Tech/billing support - Booking ${booking.id}`}
            tags={[SupportMessageTags.OTHER]}
          />
        </HelpButton>
      </Row>
    </div>
  );
}
